<template>
  <div>
    <div class="doc">
      <div class="media doc-title hoverable-background" @click="showDocInfo">
        <div class="media-content">
          <div>
            <p class="subtitle is-5 has-text-link has-text-weight-medium">
              <span>{{ doc.name }}</span>
            </p>
          </div>
          <slot name="about">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item qwe">
                  <a class="button is-text has-text-grey">
                    <img
                      class="icon image is-16x16"
                      src="../../assets/svg/about_obj.svg"
                    />
                    <span class="hoverable-underline">о документе</span>
                  </a>
                </div>
              </div>
            </div>
          </slot>
        </div>
        <div
          class="media-right doc-collapse"
          @click.stop="collapsed = !collapsed"
        >
          <img v-if="!collapsed" src="../../assets/svg/chevron-upx2.svg" />
          <img v-else src="../../assets/svg/chevron-downx2.svg" />
        </div>
      </div>

      <div v-if="!collapsed">
        <geo-feature
          v-for="gf in doc.geoFeatures"
          :geo-feature="gf"
          :key="gf.key"
          :isLayerVisible="isLayerVisible(gf, visibleLayers)"
          @click="setActiveGeoFeature"
          @highlightGeometry="setHighlightedGeometry"
          @toggleLayer="toggleLayer"
        ></geo-feature>
      </div>
    </div>
    <hr class="is-marginless has-background-grey-light" />
  </div>
</template>
<script>
import GeoFeature from "./GeoFeature";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    doc: {
      type: Object,
      required: true,
    },
    showAbout: {
      default: true,
    },
  },
  components: {
    GeoFeature,
  },
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    ...mapGetters(["visibleLayers"]),
    isIsogdSection13() {
      return this.doc.gisogdSection === "razdel13";
    },
  },
  methods: {
    ...mapActions([
      "setActiveGeoFeature",
      "setActiveGroup",
      "setActiveIsogdDoc",
      "setHighlightedGeometry",
      "toggleLayer",
    ]),
    isLayerVisible(geoFeature, visibleLayers) {
      return (
        visibleLayers &&
        visibleLayers.find((layer) => layer.name === geoFeature.layerName) !=
          null
      );
    },
    showDocInfo() {
      if (!this.showAbout) return;
      if (this.isIsogdSection13) this.setActiveIsogdDoc(this.doc);
      else this.setActiveGroup(this.doc);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/sass/main.scss";

.doc {
  padding: 1rem 1.5rem 0 1.5rem;
}

.doc-title {
  margin: -1rem -1.5rem 0;
  padding: 1rem 1.5rem 0;
}

.doc-collapse {
  display: flex;
  align-self: stretch;
}
.doc-collapse img {
  height: fit-content;
}

.media {
  cursor: pointer;
}

.qwe {
  padding-bottom: 0.5rem;
}
</style>
